import AppDialog from 'components/AppDialog'
import AppLayout from 'components/AppLayout'
import React from 'react'

interface Item {
	field?: string
	title?: string
}

export interface Props {
	colList?: any[]
	index?: number
	onchange?: (value: any) => void
}
export default class OptionAdd extends React.Component<Props, {}> {
	state = {
		data: this.props.colList || ([] as Item[]),
	}
	onsave = () => {
		let data = {}
		if (data) {
			const type = 'id'
			data[type] = this.props.index || '0'
			this.props.onchange && this.props.onchange(data)
			AppDialog.close()
		}
	}
	onclose = () => {
		AppDialog.close()
	}
	render() {
		const { data } = this.state
		return (
			<AppLayout mode="col">
				{/* <AppLayout.ColFix>
					<div className="app-form">
						{data &&
							data.length > 0 &&
							data.map((field, index) => {
								return (
									<AppInput
										key={field.field + index}
										label={field.title}									
										value={''}									
									/>
								)
							})}
					
					</div>
				</AppLayout.ColFix>
				<AppFormMenu>
					<AppAction title="保存" type="primary" action={this.onsave} />
					<AppAction title="取消" action={this.onclose} />
				</AppFormMenu> */}
			</AppLayout>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/OptionAdd.tsx